import Joi from 'joi';
import DynamicDataType from '../enums/dynamic-data-type';

const PaymentOptions = Joi.object().keys({
  dpaDynamicDataTtlMinutes: Joi.number().integer(),
  dpaPanRequested: Joi.boolean().default(false),
  dynamicDataType: DynamicDataType
});

export default PaymentOptions;
